import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
//import bottom5RetailersData from '../data/bottom5.json';
import { isEmptyObject, getJCJPIDs } from "../../../../../utils/common/index";
import Bottom5RetailersView from "../../../../../views/activationSales/components/simConnectivity/bottom5RetailersView";

const Bottom5Retailers = (props) => {
  const dispatch = useDispatch();
  const { bottom5RetailersObj } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    url,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerBottom5RetailersAPI,
  } = props;

  let { level, jioPointId, partnerRT, retailerId, id } = getJCJPIDs(filterValue);

  const headers = {
    id: id,
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    jioPointId,
    retailerId,
    level,
  };

  useEffect(() => {
    function fetchBottom5RetailersData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerBottom5RetailersAPI(obj));
    }
    if (
      isEmptyObject(
        bottom5RetailersObj && bottom5RetailersObj.bottom5RetailersData
      )
    ) {
      fetchBottom5RetailersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerBottom5RetailersAPI,
    headerSelectedDateFrom,
    headerSelectedDateTo,
  ]);

  return (
    <Bottom5RetailersView 
      bottom5RetailersObj={bottom5RetailersObj}
    />
  );
};

Bottom5Retailers.propTypes = {
  url: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerTop5RetailersAPI: PropTypes.func,
};


export default Bottom5Retailers;